import { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";

import { FormTitle, DatePickerField, Text, SelectField } from "ui-components/Form";
import { useQuery } from "@tanstack/react-query";
import { useSKUOptions } from "hooks/useQueryHook";
import { getOrderShelfLife } from "services/data.outbound.service";
import { getPackTypeUOM } from "services/data.internal.service";
import { ReadOnlyTextField } from "ui-components/Form";
import { useVendorOptions } from "hooks/useQueryHook";
import { numberValidation } from "layouts/views/common/validation";

function SODetail({
  detailRender,
  values,
  control,
  errors,
  setValue,
  getValues,
  setDefaultVC,
  mode = "ADD",
}) {
  const { customerCode, skuCode, vendorCode, consigneeCode, orderQty, orderUOM } = values;
  const [status, newItem] = getValues(["status", "newItem"]);
  const [skuOptions, setSKUOptions] = useState([]);
  const [uomOptions, setUOMOptions] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);

  // useEffect(() => {
  //   if (status !== "Open" || orderQty === 0) return;
  //   const uom = orderUOM;
  //   const quantity = orderQty * (uom ? uom.value : 0);
  //   setValue("quantity", quantity);
  // }, [orderQty]);

  // useEffect(() => {
  //   if (status !== "Open" || orderUOM === null) return;
  //   const uom = orderUOM ? orderUOM.value : 0;
  //   const quantity = orderQty * uom;
  //   setValue("quantity", quantity);
  // }, [orderUOM]);

  useSKUOptions({
    customerCode,
    onSuccess: (data) => {
      setSKUOptions(
        data.data.data.map((x) => ({
          label: x.skuCode,
          value: x.skuCode,
          description: x.descriptions1,
          unitPrice: x.costPrice,
          currencyCode: x.currencyCode,
        }))
      );
    },
  });

  const enabled = Boolean(skuCode && customerCode && vendorCode && status === "Open");

  useQuery({
    queryKey: ["pack-type-uom", { skuCode, customerCode, vendorCode }],
    queryFn: () => getPackTypeUOM({ skuCode, customerCode, vendorCode }),
    enabled,
    onSuccess: (data) => {
      const { packType, baseUOM, uomOptions: options } = data.data.data;
      setValue("packType", packType);
      setValue("baseUOM", baseUOM);
      setUOMOptions(options.map((x) => ({ value: x.upm, label: x.uom })));
    },
  });

  // const { consigneeCode, customerCode } = values
  useQuery({
    queryKey: ["orderShelfLife", consigneeCode, customerCode],
    queryFn: () => getOrderShelfLife({ consigneeCode, customerCode }),
    enabled: values.consigneeCode !== null && values.customerCode !== null,
    onSuccess: (data) => setValue("orderShelfLife", data.data.data),
  });

  useVendorOptions({
    customerCode,
    onSuccess: (data) => setVendorOptions(data.data.data),
    onError: () => {},
  });

  useEffect(() => {
    if (vendorOptions.length > 0) {
      setDefaultVC(vendorOptions[0]);
    }
  }, [vendorOptions]);

  const onSKUChange = (e, option) => {
    setUOMOptions([]);
    setValue("orderQty", 0);
    setValue("orderUOM", null);

    setValue("skuCode", option.value);
    setValue("skuDescription", option.description);
    setValue("unitPrice", option.unitPrice);
    setValue("currencyCode", option.currencyCode);
  };

  //   const onVendorCodeChange = (e, option) => {
  //     setValue("vendorCode", option);
  //   };

  const onUOMChange = (e, option) => {
    const uomQty = option ? option.value : 0;
    setValue("orderUOM", option, { shouldDirty: true });
    setValue("quantity", getValues("orderQty") * uomQty);
  };

  const onQtyChange = (e) => {
    const { value } = e.target;
    const orderQty = numberValidation(value);
    console.log(orderQty)
    setValue("orderQty", orderQty, { shouldDirty: true });
    const uom = getValues("orderUOM");
    const quantity = orderQty * (uom ? uom.value : 0);
    setValue("quantity", quantity);
  };

  function renderFn(property, index, length) {
    const { size, disabled, editable, ...data } = property;
    const xs = size ? size : 12 / length;
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
      ...(mode === "EDIT" &&
        newItem === false &&
        editable === false && { disabled: true, type: "text" }),
      ...(mode === "EDIT" && status !== "Open" && status !== "NotEnoughStock" && status !== "BackOrder" && { disabled: true, type: "readonly" }),
      ...(data.name === "orderQty" && { onChange: onQtyChange }),
    };
    let renderField;
    switch (fieldProps.type) {
      case "text":
      case "number":
        renderField = <Text field={fieldProps} />;
        break;
      case "readonly":
        renderField = <ReadOnlyTextField field={fieldProps} />;
        break;
      case "select":
        let options = [];
        let onChange = null;
        switch (data.name) {
          case "skuCode":
            options = skuOptions;
            onChange = onSKUChange;
            break;
          case "vendorCode":
            options = vendorOptions;
            //onChange = onVendorCodeChange;
            break;
          case "orderUOM":
            options = uomOptions;
            onChange = onUOMChange;
            break;
        }
        renderField = <SelectField field={fieldProps} options={options} onChange={onChange} />;
        break;
      case "date":
        renderField = <DatePickerField field={fieldProps} />;
        break;
    }
    return (
      <Grid key={index} item xs={xs}>
        {renderField}
      </Grid>
    );
  }

  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit SO Detail" : "Add SO Detail"} />
      <MDBox mt={1.625}>
        {detailRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((row, index) => renderFn(row, index, rows.length))}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default SODetail;
